// 当前系统支持的语言
export const enum Language {
  // 未知的语言类型, 数据异常时会显示
  Unknown = 'unknown',
  // 原始文案 / 语言, 用户写入的文案内容,本身不具备语言属性, 不属于某一特定语言;
  SOURCE = 'source',
  // 中文
  ZH = 'zh',
  // 英文(默认含义为美式英语)
  EN = 'en',
  // 日文
  JA = 'ja',
}

// 系统支持的语言(数组版)
export const LanguageArray: Language[] = [
  Language.Unknown,
  Language.SOURCE,
  Language.ZH,
  Language.EN,
  Language.JA,
];

// 枚举到语言代码的映射关系
export const LanguageEnumToCode: Record<Language, string> = {
  // 未知
  [Language.Unknown]: 'unknown',
  // 源文案
  [Language.SOURCE]: 'source',
  // 中文(简体中文)
  [Language.ZH]: 'zh-CN',
  // 英语(美式英语)
  [Language.EN]: 'en-US',
  // 日语(日语)
  [Language.JA]: 'ja-JP',
};

/**
 * 语言代码到枚举的映射关系;
 */
export const LanguageCodeToEnum = /*#__PURE__*/ (() => new Proxy({} as Record<string, Language>, {
  get(t: Record<string, Language>, p: string): Language {
    if (t[p] !== undefined) {
      return t[p];
    }
    const code = p?.trim().toLowerCase() || '';
    if (code === 'unknown') {
      return (t[p] = Language.Unknown);
    } else if (code === 'source') {
      return (t[p] = Language.SOURCE);
    } else if (code.startsWith('zh')) {
      // 中文语系
      return (t[p] = Language.ZH);
    } else if (code.startsWith('en')) {
      // 英文语系
      return (t[p] = Language.EN);
    } else if (code.startsWith('ja') || code === 'jp') {
      // 日语语系
      return (t[p] = Language.JA);
    }
    // 对于没有识别的语言code（小语种）,采用英文兜底
    return (t[p] = Language.EN);
  },
  set(): boolean {
    throw new Error('can not set value to LanguageCodeToEnum');
  },
}))();

// 真正的语言类型
export type RealLanguage = Language.ZH | Language.EN | Language.JA;
export const RealLanguageMap: Record<RealLanguage, true> = {
  [Language.ZH]: true,
  [Language.EN]: true,
  [Language.JA]: true,
};
export const RealLanguageArray: RealLanguage[] = [Language.ZH, Language.EN, Language.JA];

// 源文案加真正的语言类型
export type ComLanguage = Language.SOURCE | RealLanguage;
export const ComLanguageMap: Record<ComLanguage, true> = /*#__PURE__*/ (() => ({
  [Language.SOURCE]: true,
  ...RealLanguageMap,
}))();
export const ComLanguageArray: ComLanguage[] = /*#__PURE__*/ (() => [Language.SOURCE, ...RealLanguageArray])();

/**
 * Meego中, 语言代码到枚举的映射关系;
 * 这里是个代理对象, 会比较智能的判断入参,给出合适的目标语言
 */
export const RealLanguageCodeToEnum = /*#__PURE__*/ (() => new Proxy({} as Record<string, RealLanguage>, {
  get(t: Record<string, RealLanguage>, p: string): RealLanguage {
    if (t[p] !== undefined) {
      return t[p];
    }
    const code = p?.trim().toLowerCase() || '';
    if (code === 'unknown' || code === 'source') {
      return (t[p] = Language.EN);
    }
    return LanguageCodeToEnum[code] as RealLanguage;
  },
  set(): boolean {
    throw new Error('can not set value to LanguageCodeToEnum');
  },
}))();

// Language的排序索引大小
export const LanguageSortIndexMap = /*#__PURE__*/ (() => new Proxy({} as Record<Language, number>, {
  get(t: Record<Language, number>, p: Language): number {
    if (t[p] !== undefined) {
      return t[p];
    }
    if (p === Language.Unknown) {
      return (t[p] = 9999);
    }
    const index = LanguageArray.findIndex(l => l === p);
    if (index === -1) {
      return (t[p] = 999);
    }
    return (t[p] = index);
  },
  set(): boolean {
    throw new Error('can not set value to LanguageIndexMap');
  },
}))();
